import { useTranslation } from "react-i18next";
import "./SideBar.css";

const SideBar = () => {
    const { t } = useTranslation();
    return (
        <aside className="SideBar border-shadow" aria-label={t("sidebar.profileLabel")}>
            <img className="omakuva" src="/images/oma_kuva.webp" alt={t("about.imageAlt")} width="573" height="559" decoding="async" fetchPriority="high" />
            <ul>
                <li>
                    <a href="https://github.com/Janicxz" target="_blank" rel="noopener noreferrer">GitHub</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/jani-luostarinen-9071a8316/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </li>
                <li><a href="https://www.credly.com/users/jani-luostarinen" target="_blank" rel="noopener noreferrer">Credly</a></li>
                <li>
                    <a href="mailto:janijluostarinen@gmail.com"> <i className="fa fa-envelope" aria-hidden="true"></i> janijluostarinen@gmail.com</a>
                </li>
                <li>
                    <a href="tel:+358456413228"><i className="fa fa-phone" aria-hidden="true"></i> +358 45 641 3228</a>
                </li>
                <li>
                    <p><i className="fa fa-map-pin" aria-hidden="true"></i> Lieksa, {t("sidebar.finland")}</p>
                </li>
                <li>
                    <p>{t("sidebar.spokenLanguages")}</p>
                </li>
                <li>
                    <p>{t("sidebar.lastUpdated")} 18.7.2026</p>
                </li>
            </ul>
        </aside>
    );
};
export default SideBar;
